var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 19 2"}},[_c('rect',{attrs:{"width":"19","height":"1.5","fill":_vm.color,"rx":".75"}})])}
var staticRenderFns = []

export { render, staticRenderFns }